import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {IndexTemplate} from '@github-ui/swp-core/layouts/contentful/IndexTemplate'
import {DynamicIndexTemplate} from '@github-ui/swp-core/layouts/contentful/DynamicIndexTemplate'
import {toIndexPage} from '@github-ui/swp-core/schemas/contentful/contentTypes/indexTemplate'
import resolveResponse from 'contentful-resolve-response'
import {toEntryCollection} from '../../lib/types/contentful'
import {isDynamicIndexPayload, toDynamicIndexPayload, toIndexPayload} from '../../lib/types/generic-payload'

export function IndexPage() {
  const rawPayload = useRoutePayload<unknown>()

  // Check if this is the dynamic resources payload
  if (isDynamicIndexPayload(rawPayload)) {
    const {contentfulRawJsonResponse, topics, resources, additionalProps} = toDynamicIndexPayload(rawPayload)
    const page = toIndexPage(toEntryCollection(resolveResponse(contentfulRawJsonResponse)).at(0))
    return <DynamicIndexTemplate page={page} topics={topics} resources={resources} additionalProps={additionalProps} />
  }

  // Otherwise, render the manual-based index page
  const {contentfulRawJsonResponse, additionalProps} = toIndexPayload(rawPayload)
  const page = toIndexPage(toEntryCollection(resolveResponse(contentfulRawJsonResponse)).at(0))

  return <IndexTemplate page={page} additionalProps={additionalProps} />
}

try{ IndexPage.displayName ||= 'IndexPage' } catch {}